import { store } from "../../../../..";
import { DictionaryDto } from "../../../../../lib/interfaces";
import { camelizeString } from "../../../utils/camelizeString";

export const getCamelizeDictionaries = (type: string): DictionaryDto[] => {
  const typesCharacteristicsStore = store?.getState()?.typesCharacteristics;

  if (typesCharacteristicsStore) {
    const camelizeType = camelizeString(type);
    return typesCharacteristicsStore[camelizeType];
  }
  return [];
};
